const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000"
const WS_URL = process.env.REACT_APP_WS_URL || "ws://localhost:8000"

export const APP_CONFIG = {
  API_URL,
  WS_URL,
}